import { useEffect } from 'react';

import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import _ from 'lodash';
import { IntlConfig } from 'react-intl';
import { Provider } from 'react-redux';
import { BrowserRouter, Route, Routes } from 'react-router-dom';

import SignupRoutesUK from '@src/containers/Routes/SignupRoutesUK';

import SignupContainer from './containers/Containers';
import GetStartedUK from './containers/GetStarted/GetStartedUK';
import LanguageProvider from './containers/LanguageProvider';
import SignupRoutesDE from './containers/Routes/SignupRoutesDE';
import NewRequestLayout from './containers/SignupLayout/NewRequestLayout/NewRequestLayout';
import SignupLayout from './containers/SignupLayout/SignupLayout';
import createStore from './createStore';
import { getOrSetAnonymousSplitTestUID } from './helpers/helpers';
import NavigationProvider from './hooks/useNavigation';
import { initialiseTracking } from './tracking/trackingSetup.helper';
import deBrokerCustomisations from './translations/de.broker.json';
import de from './translations/de.json';
import enBroker from './translations/en.broker.json';
import en from './translations/en.json';
import { isIwocaDE } from './utils/countryHelper';

window.global ||= window;

type TMessages = {
    en?: IntlConfig['messages'];
    de?: IntlConfig['messages'];
    enBroker?: IntlConfig['messages'];
    deBroker?: IntlConfig['messages'];
};

export const store = createStore();

function prepareMessages(): TMessages {
    const deBroker = _.assign({}, de, deBrokerCustomisations);
    return { en, enBroker, de, deBroker };
}

export const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            retry: false,
            refetchOnWindowFocus: false
        }
    }
});

const App = () => {
    const isDE = isIwocaDE();

    useEffect(() => {
        getOrSetAnonymousSplitTestUID();
        initialiseTracking();
    }, []);

    useEffect(() => {
        store.dispatch({ type: 'APPLICATION_STATE_FETCH_REQUESTED' });
    }, []);

    //@ts-ignore
    if (window.Cypress) {
        //@ts-ignore
        window.store = store;
    }

    return (
        //@ts-ignore
        <Provider store={store}>
            <QueryClientProvider client={queryClient}>
                <LanguageProvider messages={prepareMessages()}>
                    <BrowserRouter>
                        <NavigationProvider>
                            <SignupContainer>
                                <Routes>
                                    {!isDE && (
                                        <>
                                            <Route
                                                path="/account/signup/apply-now"
                                                element={
                                                    <NewRequestLayout>
                                                        <GetStartedUK />
                                                    </NewRequestLayout>
                                                }
                                            />
                                            <Route
                                                path={'/account/signup/*'}
                                                element={
                                                    <SignupLayout>
                                                        <SignupRoutesUK />
                                                    </SignupLayout>
                                                }
                                            />
                                        </>
                                    )}
                                    {isDE && (
                                        <Route
                                            path={'/konto/anmeldung/*'}
                                            element={
                                                <SignupLayout>
                                                    <SignupRoutesDE />
                                                </SignupLayout>
                                            }
                                        />
                                    )}
                                </Routes>
                            </SignupContainer>
                        </NavigationProvider>
                    </BrowserRouter>
                </LanguageProvider>
            </QueryClientProvider>
        </Provider>
    );
};

export default App;
